import Alarm from "./Alarm";

export default Alarm